const DITypes = {
  SocketProcessingAdapter: Symbol('SocketProcessingAdapter'),
  UploadDispatcherFactory: Symbol('UploadDispatcherFactory'),
  UploadDispatcher: Symbol('UploadDispatcher'),
  UploadAdapter: Symbol('UploadAdapter'),
};

export default DITypes;
